
import { defineComponent, ref } from "vue";
import FilterCurrents from "@/components/filters/FilterCurrents.vue";
import { toolbarWidthFluid } from "@/core/helpers/config";

export default defineComponent({
  name: "toolbar-currents",
  emits: ["applyfilter"],
  props: {
    breadcrumbs: Array,
    title: String,
  },
  components: {
    FilterCurrents,
  },
  setup(props, { emit }) {
    let dateFilter = ref(null) as any;
    let theFilter = ref();
    const propageFilters = (filter) => {
      dateFilter.value = filter;
      // console.log("Segundo componente");
      // console.log(filter);
      emit("applyfilter", filter);
    };

    function setFilterDate(arrayDates) {
      // Filter forced by insertion of incident
      dateFilter.value = {
        startDate: arrayDates[0],
        endDate: arrayDates[1],
      };
      theFilter.value.setFilterDate(arrayDates);
    }

    return {
      toolbarWidthFluid,
      propageFilters,
      dateFilter,
      theFilter,
      setFilterDate,
    };
  },
});
